import { useSelector } from "react-redux";
import { List, X } from "lucide-react";
import classes from "./dashboard-rotate-table.module.scss";

const DashboardRotateTable = ({ periodLabel, modalProducts, closeModal }) => {
	const type_currency = useSelector((state) => state.auth?.filter?.type_currency);

	return (
		<div className={classes.modalOverlay} onClick={closeModal}>
			<div className={classes.modalContent} onClick={(e) => e.stopPropagation()}>
				<header className={classes.titleBar}>
					<List size={20} className={classes.titleIcon} />
					<h2 className={classes.titleText}>{periodLabel}</h2>
					<X size={20} className={classes.closeIcon} onClick={closeModal} />
				</header>
				<div className={classes.tableWrapper}>
					<table className={classes.table}>
						<thead>
							<tr>
								<th>Producto</th>
								<th>Códigos</th>
								<th>Últ. movimiento</th>
								<th className={classes.right}>Cant.</th>
								<th className={classes.right}>Valor</th>
								<th>Campo</th>
								<th>Bodega</th>
							</tr>
						</thead>
						<tbody>
							{modalProducts.map((pr, idx) => (
								<tr key={idx} className={classes.row}>
									<td>{pr.name}</td>
									<td>{pr.codes.join(", ")}</td>
									<td>{pr.last_move ? new Date(pr.last_move).toLocaleDateString("es-CL") : ""}</td>
									<td className={classes.right}>{pr.quantity}</td>
									<td className={classes.right}>
										{type_currency === "CLP"
											? new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP", maximumFractionDigits: 0 }).format(
													pr.total_value_locale,
												)
											: new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(
													pr.total_value_usd,
												)}
									</td>
									<td>{pr.estate.parent_name}</td>
									<td>{pr.estate.name}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	);
};

export default DashboardRotateTable;
